import type { Category } from '@/mocks/categories';

export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  author: string;
  publishDate: string;
  readTime: string;
  viewCount: number;
  featured: boolean;
  rating: number;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '《流浪地球3》定档2026年春节，郭帆导演续写科幻传奇',
    slug: 'the-wandering-earth-3-release-date',
    excerpt: '备受期待的国产科幻巨制《流浪地球3》正式宣布定档2026年春节档。导演郭帆表示，本片将采用全新的虚拟拍摄技术，视觉效果将再次升级。吴京、刘德华确认回归出演，故事将聚焦人类在新家园的生存挑战。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20movie%20scene%20with%20space%20station%20and%20stars%2C%20cinematic%20lighting%2C%20grand%20scale%2C%20warm%20golden%20and%20orange%20tones%2C%20dramatic%20atmosphere%2C%20high%20quality%20film%20poster%20style%2C%20clean%20background%20with%20deep%20space%20elements&width=800&height=450&seq=article-cover-01&orientation=landscape',
    category: '电影资讯',
    categorySlug: 'movie-news',
    tags: ['流浪地球', '科幻', '郭帆', '2026春节档', '国产电影'],
    author: '影评人小王',
    publishDate: '2026-08-10',
    readTime: '5分钟',
    viewCount: 12890,
    featured: true,
    rating: 8.5,
  },
  {
    id: '2',
    title: 'Netflix年度韩剧《王国》前传确认开发，全智贤领衔主演',
    slug: 'kingdom-prequel-netflix-2026',
    excerpt: 'Netflix正式确认开发《王国》系列前传，讲述丧尸瘟疫爆发的起源故事。全智贤将饰演关键角色，制作团队表示前传的规模将超越前两季。预计2026年底上线。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20cinematic%20scene%20with%20traditional%20costumes%2C%20dark%20atmospheric%20lighting%2C%20palace%20setting%2C%20mysterious%20mood%2C%20warm%20amber%20tones%2C%20film%20poster%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=article-cover-02&orientation=landscape',
    category: '剧集推荐',
    categorySlug: 'series-recommend',
    tags: ['Netflix', '韩剧', '王国', '全智贤', '丧尸'],
    author: '追剧达人',
    publishDate: '2026-08-09',
    readTime: '4分钟',
    viewCount: 9650,
    featured: true,
    rating: 8.8,
  },
  {
    id: '3',
    title: '国产动画《深海2》制作进度曝光，田晓鹏导演再度挑战视觉极限',
    slug: 'deep-sea-2-animation-progress',
    excerpt: '继《深海》以惊艳的粒子水墨画风震惊业界后，导演田晓鹏的续作《深海2》首次公开制作进度。据悉本片将采用全新的粒子渲染引擎，画面精细度提升三倍。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20underwater%20scene%20with%20colorful%20particle%20effects%2C%20dreamy%20ocean%20world%2C%20ink%20painting%20style%2C%20ethereal%20lighting%2C%20warm%20and%20cool%20color%20contrast%2C%20cinematic%20poster%20quality%2C%20clean%20background&width=800&height=450&seq=article-cover-03&orientation=landscape',
    category: '动漫动画',
    categorySlug: 'anime',
    tags: ['深海', '国产动画', '田晓鹏', '粒子水墨', '动画电影'],
    author: '动漫迷阿杰',
    publishDate: '2026-08-08',
    readTime: '6分钟',
    viewCount: 7820,
    featured: false,
    rating: 9.0,
  },
  {
    id: '4',
    title: '《漫长的季节》导演新作曝光：聚焦90年代东北工业变迁',
    slug: 'long-season-director-new-work',
    excerpt: '凭借《漫长的季节》获得广泛赞誉的导演辛爽，新作将聚焦90年代东北老工业基地的转型故事。范伟、秦昊再度合作，预计2027年播出。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=nostalgic%201990s%20Chinese%20industrial%20cityscape%20with%20old%20factories%2C%20warm%20vintage%20film%20tones%2C%20cinematic%20composition%2C%20winter%20atmosphere%2C%20orange%20sunset%20light%2C%20film%20poster%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=article-cover-04&orientation=landscape',
    category: '剧集推荐',
    categorySlug: 'series-recommend',
    tags: ['漫长的季节', '辛爽', '范伟', '秦昊', '年代剧'],
    author: '追剧达人',
    publishDate: '2026-08-07',
    readTime: '5分钟',
    viewCount: 11230,
    featured: true,
    rating: 9.2,
  },
  {
    id: '5',
    title: '2026年暑期档票房突破80亿，《封神第二部》领跑',
    slug: '2026-summer-box-office-80-billion',
    excerpt: '2026年暑期档总票房突破80亿元大关，创下历史新高。《封神第二部》以28亿票房领跑，《哪吒3》《熊出没11》紧随其后，国产电影占比超85%。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=grand%20Chinese%20movie%20theater%20exterior%20with%20bright%20cinema%20lights%20and%20crowds%2C%20modern%20architecture%2C%20vibrant%20warm%20lighting%2C%20film%20posters%20displayed%2C%20celebratory%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-cover-05&orientation=landscape',
    category: '电影资讯',
    categorySlug: 'movie-news',
    tags: ['暑期档', '票房', '封神', '哪吒', '国产电影'],
    author: '影评人小王',
    publishDate: '2026-08-06',
    readTime: '7分钟',
    viewCount: 15320,
    featured: false,
    rating: 7.8,
  },
  {
    id: '6',
    title: '宫崎骏新作《风之轨迹》发布首支预告，这是他的真正告别作？',
    slug: 'hayao-miyazaki-wind-trail-trailer',
    excerpt: '82岁的宫崎骏发布新作《风之轨迹》首支预告片，影片讲述一位少女与风之精灵的奇幻冒险。吉卜力工作室表示这可能是宫崎骏真正的封笔之作。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20animation%20scene%20with%20girl%20flying%20in%20sky%2C%20soft%20clouds%2C%20green%20landscape%20below%2C%20warm%20sunlight%2C%20hand-drawn%20aesthetic%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-cover-06&orientation=landscape',
    category: '动漫动画',
    categorySlug: 'anime',
    tags: ['宫崎骏', '吉卜力', '动画电影', '日本动画', '风之轨迹'],
    author: '动漫迷阿杰',
    publishDate: '2026-08-05',
    readTime: '4分钟',
    viewCount: 18450,
    featured: true,
    rating: 9.5,
  },
  {
    id: '7',
    title: '《甄嬛传》播出15周年：为什么它依然是中国宫斗剧天花板？',
    slug: 'zhen-huan-zhuan-15th-anniversary',
    excerpt: '《甄嬛传》播出15周年之际，我们回顾这部现象级宫斗剧为何能够经久不衰。从剧本到表演，从服化道到台词，全方位解析其成功密码。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=traditional%20Chinese%20palace%20interior%20with%20elegant%20decor%2C%20imperial%20furniture%2C%20warm%20candlelight%2C%20historical%20drama%20aesthetic%2C%20ornate%20details%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-cover-07&orientation=landscape',
    category: '剧集推荐',
    categorySlug: 'series-recommend',
    tags: ['甄嬛传', '宫斗剧', '经典回顾', '孙俪', '国产剧'],
    author: '追剧达人',
    publishDate: '2026-08-04',
    readTime: '8分钟',
    viewCount: 21300,
    featured: false,
    rating: 9.4,
  },
  {
    id: '8',
    title: 'AI技术在影视制作中的应用：从剧本生成到视觉特效的革命',
    slug: 'ai-in-film-production-2026',
    excerpt: '随着AI技术的飞速发展，影视行业正在经历前所未有的变革。从AI辅助剧本创作到实时虚拟拍摄，从智能剪辑到自动化特效，人工智能正在重塑整个产业链。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20film%20production%20studio%20with%20holographic%20displays%20and%20AI%20interfaces%2C%20modern%20technology%2C%20warm%20ambient%20lighting%2C%20sleek%20design%2C%20cinematic%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-cover-08&orientation=landscape',
    category: '电影资讯',
    categorySlug: 'movie-news',
    tags: ['AI', '影视制作', '科技', '虚拟拍摄', '特效'],
    author: '科技影评人',
    publishDate: '2026-08-03',
    readTime: '6分钟',
    viewCount: 8760,
    featured: false,
    rating: 8.0,
  },
  {
    id: '9',
    title: '《咒术回战》最终章动画确认制作，MAPPA社长亲自挂帅',
    slug: 'jujutsu-kaisen-final-season',
    excerpt: '人气动画《咒术回战》确认将制作最终章，MAPPA社长表示将投入全社最精锐力量。漫画原作者芥见下下将参与剧本监修，确保动画剧情与漫画完美衔接。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=anime%20action%20scene%20with%20dynamic%20pose%20and%20energy%20effects%2C%20dark%20urban%20setting%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20dramatic%20lighting%2C%20warm%20orange%20accents%2C%20clean%20composition&width=800&height=450&seq=article-cover-09&orientation=landscape',
    category: '动漫动画',
    categorySlug: 'anime',
    tags: ['咒术回战', 'MAPPA', '日本动画', 'Jump漫画', '最终章'],
    author: '动漫迷阿杰',
    publishDate: '2026-08-02',
    readTime: '4分钟',
    viewCount: 14680,
    featured: false,
    rating: 9.1,
  },
  {
    id: '10',
    title: '演技派新生代崛起：盘点2026年最值得关注的五位青年演员',
    slug: 'top-5-young-actors-2026',
    excerpt: '2026年国产影视圈涌现出一批实力派青年演员。本文盘点五位最具潜力的新生代演员，他们用作品证明演技才是立身之本。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20Chinese%20actors%20portrait%20group%20in%20modern%20studio%20setting%2C%20soft%20professional%20lighting%2C%20fashionable%20style%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20background%2C%20editorial%20photography%20quality&width=800&height=450&seq=article-cover-10&orientation=landscape',
    category: '电影资讯',
    categorySlug: 'movie-news',
    tags: ['青年演员', '演技派', '新生代', '国产影视', '盘点'],
    author: '影评人小王',
    publishDate: '2026-08-01',
    readTime: '6分钟',
    viewCount: 9100,
    featured: false,
    rating: 7.5,
  },
  {
    id: '11',
    title: '《武林外传》导演新喜剧定档，姚晨闫妮有望客串回归',
    slug: 'wu-lin-wai-zhuan-director-new-comedy',
    excerpt: '经典情景喜剧《武林外传》导演尚敬时隔18年再拍喜剧电影，讲述当代都市小人物的爆笑故事。据透露姚晨、闫妮将友情客串，引发粉丝强烈期待。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20comedy%20setting%20with%20warm%20cozy%20inn%20interior%2C%20lanterns%20and%20wooden%20furniture%2C%20nostalgic%20atmosphere%2C%20soft%20amber%20lighting%2C%20film%20poster%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=article-cover-11&orientation=landscape',
    category: '电影资讯',
    categorySlug: 'movie-news',
    tags: ['武林外传', '喜剧', '尚敬', '姚晨', '闫妮'],
    author: '影评人小王',
    publishDate: '2026-07-31',
    readTime: '4分钟',
    viewCount: 20100,
    featured: false,
    rating: 8.3,
  },
  {
    id: '12',
    title: '《人生切割术》第二季口碑炸裂，职场科幻讽刺戳中打工人内心',
    slug: 'severance-season-2-review',
    excerpt: 'Apple TV+神剧《人生切割术》第二季回归，豆瓣评分9.3分。这部将职场文化与科幻悬疑完美融合的作品，让无数打工人看完直呼「这就是我」。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20office%20corridor%20with%20sterile%20white%20walls%20and%20geometric%20patterns%2C%20surreal%20atmosphere%2C%20mysterious%20lighting%2C%20corporate%20aesthetic%2C%20clean%20cinematic%20composition%2C%20warm%20undertones&width=800&height=450&seq=article-cover-12&orientation=landscape',
    category: '剧集推荐',
    categorySlug: 'series-recommend',
    tags: ['人生切割术', 'Apple TV+', '科幻', '职场', '美剧'],
    author: '追剧达人',
    publishDate: '2026-07-30',
    readTime: '5分钟',
    viewCount: 7650,
    featured: false,
    rating: 9.3,
  },
];